var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscordRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#a6fa9f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.034 19.629a30.92 30.92 0 0 0-7.832-2.461 22.98 22.98 0 0 0-1.003 2.083c-2.92-.439-5.814-.439-8.68 0a22.27 22.27 0 0 0-1.015-2.083 30.82 30.82 0 0 0-7.838 2.467c-4.957 7.49-6.3 14.794-5.628 21.995 3.287 2.455 6.474 3.946 9.606 4.922a23.89 23.89 0 0 0 2.057-3.388 20.23 20.23 0 0 1-3.24-1.577 16.11 16.11 0 0 0 .794-.628c6.247 2.922 13.034 2.922 19.206 0a19.53 19.53 0 0 0 .794.628 20.18 20.18 0 0 1-3.246 1.58 23.79 23.79 0 0 0 2.057 3.388c3.135-.976 6.324-2.467 9.612-4.925.788-8.347-1.347-15.584-5.643-22.001zM25.551 37.202c-1.875 0-3.413-1.751-3.413-3.882s1.505-3.885 3.413-3.885 3.446 1.75 3.413 3.885c.003 2.132-1.505 3.882-3.413 3.882zm12.613 0c-1.875 0-3.413-1.751-3.413-3.882s1.505-3.885 3.413-3.885 3.446 1.75 3.413 3.885c0 2.132-1.505 3.882-3.413 3.882z",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordRound);
export default __webpack_public_path__ + "static/media/discord_round.68fc5742a1d25f40b8b62dcc9ec9e2b1.svg";
export { ForwardRef as ReactComponent };